import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import TopNavBar2 from './components/Shared/TopNavBar2';
import CookieBanner from './components/Shared/CookieBanner';
import TermsGate from './components/User/TermsGate';
import Footer from './components/Shared/Footer';
import ScrollToTop from './components/Shared/ScrollToTop';
import AppRoutes from './Routes'; // <-- Import your routes here
import './styles/App.css';
import { CartProvider } from "./components/DeviceRequests/CartContext";

function App() {
  const [user, setUser] = useState(localStorage.getItem("username") || "");
  const navigate = useNavigate();

  // Login.js performs the request and writes localStorage; this only lifts the
  // result into React state so the nav re-renders. It used to take
  // (username, password) and POST again, while Login.js called it with the
  // response object -- so a successful sign-in fired a second login request
  // with the whole response as the username.
  const handleLogin = (data) => {
    setUser((data && (data.display_name || data.username)) || localStorage.getItem("username") || "");
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("role");
    localStorage.removeItem("roles");
    localStorage.removeItem("vendor_id");
    localStorage.removeItem("customer_id");
    setUser("");
    navigate("/"); // Redirect to home
  };

  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        // JWT exp is in seconds
        if (decoded.exp * 1000 < Date.now()) {
          // Token expired
          handleLogout();
        } else {
          // Optionally, set a timeout to auto-logout when token expires
          setTimeout(handleLogout, decoded.exp * 1000 - Date.now());
        }
      } catch (e) {
        handleLogout();
      }
    }
    // eslint-disable-next-line
  }, []);

  return (
    <CartProvider>
      <div className="App">
        {/* Route changes do not move the scroll position on their own. */}
        <ScrollToTop />
        <TopNavBar2 user={user} onLogin={handleLogin} onLogout={handleLogout} />
        {/* The spacer <header> that used to sit here only existed to push
            content below the fixed nav, via an inline marginTop. That offset
            now lives in App.css next to the nav height it depends on. */}
        <main>
          {/* Wraps the routes, not the whole app: the nav stays reachable
              above it so someone who does not want to agree can sign out,
              rather than being trapped by the prompt. */}
          <TermsGate>
            <AppRoutes handleLogin={handleLogin} />
          </TermsGate>
        </main>
        <Footer />
        {/* Last in the tree: it is fixed-position, so document order is what
            decides whether a keyboard reaches it after the page content
            rather than before it. */}
        <CookieBanner />
      </div>
    </CartProvider>
  );
}

export default App;
